module.exports = __webpack_public_path__ + "img/terraza.67ce2e40.svg";